export default __webpack_public_path__ + "static/media/blank-avatar.2fda6558.png";